import { z } from "zod";

export const hubSpotClientContextSchema = z.object({
  hutk: z.string().optional(),
  pageUri: z.url().min(3),
  pageName: z.string().min(3),
});

export type HubSpotClientContext = z.infer<typeof hubSpotClientContextSchema>;

export const hubSpotClientContextSchemaDefaultValues: HubSpotClientContext = {
  hutk: undefined,
  pageUri: "",
  pageName: "",
};
